export default {
  All: 'Tất cả',
  ALL: 'TẤT CẢ',

  New: 'Mới',
  NEW: 'MỚI',

  Approved: 'Đã duyệt',
  APPROVED: 'ĐÃ DUYỆT',

  Reading: 'Đang đọc',
  READING: 'ĐANG ĐỌC',

  Submitted: 'Đã đọc',
  SUBMITTED: 'ĐÃ ĐỌC',

  Done: 'Đã duyệt',
  DONE: 'ĐÃ DUYỆT',

  Rejected: 'Bỏ qua',
  REJECTED: 'BỎ QUA',

  Cancelled: 'Đã hủy',
  CANCELED: 'ĐÃ HỦY',
  cancelled: 'đã hủy',
  CANCELLED: 'ĐÃ HỦY',

  Matched: 'Đã thực hiện',
  MATCHED: 'ĐÃ THỰC HIỆN',

  Unmatched: 'Chưa thực hiện',

  Completed: 'Đã thực hiện',
  COMPLETED: 'ĐÃ THỰC HIỆN',

  Active: 'Đang hoạt động',
  ACTIVE: 'ĐANG HOẠT ĐỘNG',

  Deactivated: 'Không hoạt động',
  DEACTIVATED: 'KHÔNG HOẠT ĐỘNG',

  Never: 'Không giới hạn',
  NEVER: 'KHÔNG GIỚI HẠN',

  Expired: 'Hết hạn',
  EXPIRED: 'Hết hạn',

  Abnormal: 'Bất thường',
  Normal: 'Bình thường',

  OPEN: 'MỞ',
  CLOSED: 'ĐÓNG',
};
